
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    svg: { type: String, required: true },
    width: { type: Number, default: 20 },
    height: { type: Number, default: 20 }
  },
  setup(props) {
    const style = computed(() => {
      return {
        width: `${props.width}px`,
        height: `${props.height}px`
      }
    })

    return {
      style
    }
  }
})
